export default __webpack_public_path__ + "static/media/squareI.svg";